import { InternalReportProfileStruct } from "./internal-report-profile.struct";
export class ListProfileInternalReportStruct{
    public nameProfile: string;
    public idProfile:number;
    public  internalReports: InternalReportProfileStruct[];
}